import { useEffect, useState,useContext } from 'react';
import './ProjectBookingReview.css';
import {Context} from '../Context';
import newProjectBookingDataService from '../Services/ProjectBookingService';
import CustomerSelector from '../Customers/CustomerSelector';
import moment from 'moment';
import { FaFlag, FaHammer,FaSearch,FaArrowUp,FaArrowDown,FaFilePdf,FaCheck,FaBackward,FaCheckCircle,FaFileUpload,FaExternalLinkAlt,FaDownload,FaCog,FaChartBar,FaUpload,FaExclamationTriangle } from "react-icons/fa";
import { MdHomeRepairService } from "react-icons/md";
import { RotatingLines } from "react-loader-spinner";

const customerBaseRoute = 'https://cornerstoneinc.acumatica.com/(W(1))/Main?CompanyID=Pilot&ScreenId=AR303000&AcctCD=';
const serviceContractBaseRoute = 'https://cornerstoneinc.acumatica.com/Main?CompanyID=Pilot&ScreenId=FS305700&RefNbr=';
const proestBaseRoute = 'https://cloud.proest.com/projects/';

const standardBudgetUploadInstructions = 'https://cornerstonedetentionproducts.app.box.com/file/1772235704549';
const proestBudgetUploadInstructions = 'https://cornerstonedetentionproducts.app.box.com/file/1772236055502';
const sageBudgetUploadInstructions = 'https://cornerstonedetentionproducts.app.box.com/file/1850430414605';

const organizeDate = (date) => {
    return moment(date).format("MMM Do YYYY");
};

const getDate = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    
    today = mm + '.' + dd + '.' + yyyy;
    return today;
};

const organizeInputDate = (date) => {
    return moment(date).format("YYYY-MM-DD");
};

const branchOptions = [
    {text:'02 - DEC Construction', value:'02'},
    {text:'04 - Electronics', value:'04'},
    {text:'06 - C3 Mattresses', value:'06'},
    {text:'07 - Airteq Locks', value:'07'},
    {text:'09 - Modular Construction', value:'09'},
    {text:'12 - Service North', value:'12'},
    {text:'61 - Service East', value:'61'},
    {text:'62 - Service Southwest', value:'62'},
    {text:'64 - Service Southeast', value:'64'},
    {text:'66 - Service South', value:'66'},
];

const trueOrFalseOptions = [
    {text: 'Yes', value: true},
    {text: 'No', value: false},
];

const insuranceProgramOptions = [
    {text: 'Contractor Controlled Insurance Program', value: 'CCIP'},
    {text: 'Owner Controlled Insurance Program', value: 'OCIP'},
    {text: 'None', value: null}
];

const taxabilityOptions = [
    {text:'Customer Taxed', value:'Customer'},
    {text:'Contractor Taxed',value:'Contractor'},
    {text:'Exempt',value:'Exempt'},
    {text:'Other',value:'Other'},
];

const requestTypeOptions = [
    {text:'Project', value:'Project'},
    {text:'Service Contract',value:'Service'}
];

const billingOptions = [
    {text:'Complete At Start', value:'upfront'},
    {text:'On Visits', value:'onVisit'},
    {text:'Monthly', value:'monthly'},
    {text:'Quarterly', value:'quarterly'}
];


const getFilteredProjectManagers = async (apiToken,branch,setProjectManagerList,setProjectManagerError) => {
    newProjectBookingDataService.getFilteredProjectManagerList(apiToken,branch)
    .then(response =>{
        if(response.data.length > 0){
            let projectManagerOptions = [];
            response.data.forEach(element => {
                const tempPM = {text: `${element.id} - ${element.name} - ${element.email}`, value: element.id}
                projectManagerOptions.push(tempPM);
            });
            setProjectManagerList(projectManagerOptions);
            return projectManagerOptions;
        }
        else{
            setProjectManagerList([{text:'No Project Managers Listed', value:null},]);
            return null;
        }

    }).catch( e=> {
        setProjectManagerError(e.toString());
    });
};

const getServiceContracts = async (apiToken,projectId,setServiceContracts,setServiceContractsError) => {
    newProjectBookingDataService.getServiceContracts(apiToken,projectId)
    .then(response =>{
        if(response.data.serviceContracts.length > 0){
            setServiceContracts(response.data.serviceContracts);
            return response.data.serviceContracts;
        }
        else{
            return null;
        }

    }).catch( e=> {
        setServiceContractsError(e.toString());
    });
};

const openProestBudgetLink = (estimateNumber) => {
    const newWindow = window.open(proestBaseRoute+estimateNumber+'/summary', '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
};

const openProjectBookingTask = async (token, fileName) => {
    newProjectBookingDataService.getBudgetFile(token,fileName);
};

const openProjectBookingRevenue = async (token, fileName) => {
    newProjectBookingDataService.getBudgetFile(token,fileName);
};

const openProjectBookingCost = async (token, fileName) => {
    newProjectBookingDataService.getBudgetFile(token,fileName);
};

const DropDownSelection = ({title, options, setTo, width, initializedValue}) => {
    const inputCssProps = {
        '--inputWidth': `${width}px`
    };

    const selectOption = (value) => {
         setTo(value);
    };

    return(
        <div className='Customer-Request-Form-Input' style={inputCssProps}>
            <div className='Customer-Request-Form-Input-Title'>
                {title}
            </div>

            <select className='Customer-Request-Form-Dropdown' onChange={(e) => selectOption(e.target.value)} value={initializedValue || ''}>
                <option value="">Select {title}</option>
                {options.map((option, key) => (
                    <option className='Customer-Request-Form-Dropdown-Selection' key={key} value={option}>{option}</option>
                ))}
            </select>
        </div>
    )
};

const SearchBar = ({setSearchInput,searchList, selectSearchItem}) => {
    const [ focused, setFocused ] = useState(false);

    const handleSearchItemClick = (businessName) => {
        selectSearchItem(businessName);
        setFocused(false);
        document.getElementById('myInput').value = ''
        setSearchInput('');
    };

    return(      
        <div className='Header-Search' onClick={() => setFocused(true)}  onMouseLeave={() => setFocused(false)}>
            <FaSearch  className='Header-Search-Icon'/>
            <input autoComplete="off"  onChange={((e) => setSearchInput(e.target.value))} id="myInput" className='Header-Search-Text' placeholder='Search Project Requests'/>

            {   focused && searchList && 
            <div className='Header-Search-List'>
            {   
                searchList.map((object, key) => (
                    <div key={key} className='Header-Search-Term' onClick={(event) => {handleSearchItemClick(object.business_name); event.stopPropagation()}}>
                        {object.business_name}
                    </div>
                ))
            }
            </div>
            }

        </div>
    )
};

const ActiveSelector = ({activeSort,setActiveSort}) => {
    return(
        <div className='Header-Active'>

            {   activeSort && activeSort !== 'both' &&
            <div className='Header-Select Selected-Active'>
                Pending
            </div>
            }
            { activeSort === 'both' &&
            <div className='Header-Select ' onClick={() => setActiveSort(true)}>
                Pending
            </div>
            }
            {   !activeSort &&
            <div className='Header-Select ' onClick={() => setActiveSort(true)}>
                Pending
            </div>
            }


            <div className='Header-Select-Divider'/>

            {   !activeSort &&
            <div className='Header-Select Selected-Active'>
                Processed
            </div>
            }
            {   activeSort &&
            <div className='Header-Select' onClick={() => setActiveSort(false)}>
                Processed
            </div>  
            }

            <div className='Header-Select-Divider'/>

            {   activeSort === 'both' &&
            <div className='Header-Select Selected-Active'>
                All
            </div>
            }
            {   activeSort !== 'both' &&
            <div className='Header-Select' onClick={() => setActiveSort('both')}>
                All
            </div>  
            }
        </div>
    )
};

const ControlBar = ({resetList,activeSort,setActiveSort}) => {
    return(
        <div className='Header-Controls'>
            <ActiveSelector activeSort={activeSort} setActiveSort={setActiveSort}/>
            <button onClick={() => resetList()} className='Header-All-Button'>Default View</button>
        </div>
    )
};

const SortDirectionIndicator = ({currentSelection, validSelection, direction}) => {
    if(currentSelection === validSelection){
        if(direction === 'ASC') return <FaArrowUp />
        else return <FaArrowDown />
    }

};

const BottomHeader = ({screenWidth, sortDirection, orderBy, handleOrderClick}) => {
    return(
        <div className='Bottom-Header'>

            <div className='Tile-Information'>
                <div className='Tile-Data Header-Title' style={{'width':'150px'}} onClick={() => handleOrderClick('project_type')}>
                    Request Type <SortDirectionIndicator currentSelection={orderBy} validSelection={'project_type'} direction={sortDirection}/>
                </div>
                <div className='Tile-Data Header-Title' style={{'width':'250px'}} onClick={() => handleOrderClick('a.name')}>
                    Customer Name <SortDirectionIndicator currentSelection={orderBy} validSelection={'a.name'} direction={sortDirection}/>
                </div>
                <div className='Tile-Data Header-Title' style={{'width':'250px'}} onClick={() => handleOrderClick('c.name')}>
                    Project Name <SortDirectionIndicator currentSelection={orderBy} validSelection={'c.name'} direction={sortDirection}/>
                </div>
                {   screenWidth > 1150 &&
                <div className='Tile-Data Header-Title' style={{'width':'100px'}} onClick={() => handleOrderClick('branch')}>
                    Branch <SortDirectionIndicator currentSelection={orderBy} validSelection={'branch'} direction={sortDirection}/>
                </div>
                }
                {   screenWidth > 1400 &&
                <div className='Tile-Data Header-Title'style={{'width':'180px'}} onClick={() => handleOrderClick('city')}>
                    Project Location <SortDirectionIndicator currentSelection={orderBy} validSelection={'city'} direction={sortDirection}/>
                </div>
                }
                <div className='Date Header-Title'style={{'width':'150px'}} onClick={() => handleOrderClick('date')}>
                    Date Received <SortDirectionIndicator currentSelection={orderBy} validSelection={'date'} direction={sortDirection}/>
                </div>
            </div>

        </div>
    )
};

const RequestHeader = ({headerObject}) => {
    const {setSearchInput,sortDirection,flipSortOrder,screenWidth, orderBy, handleOrderClick, searchList, selectSearchItem,resetList, 
        activeSort, setActiveSort} = headerObject;

    return(
        <div className='Header'>
            <div className='Top-Header'>
                <SearchBar setSearchInput={setSearchInput} searchList={searchList} selectSearchItem={selectSearchItem}/>
                <ControlBar resetList={resetList} activeSort={activeSort} setActiveSort={setActiveSort}/>
            </div>
            <BottomHeader screenWidth={screenWidth} sortDirection={sortDirection} orderBy={orderBy} handleOrderClick={handleOrderClick} />
        </div>
    )
};

const TileHoverPanel = ({request,toggleFlag}) => {
    return (
        <div className='Flag-Frame'>
            {   request.flag &&
                <FaFlag className='Flag-Checked' onClick={(event) => {toggleFlag(request.id); event.stopPropagation()}}/>
            }
            {   !request.flag &&
                <FaFlag className='Flag-Unchecked' onClick={(event) => {toggleFlag(request.id); event.stopPropagation()}}/>
            }
            
        </div>
    )
};

const Tile = ({request, selectRecord, toggleFlag, screenWidth}) => {
    const [ hover, setHover ] = useState();

    return(
        <div className='Vender-Request-Tile' onClick={() => selectRecord(request.id)} onMouseOver={() => setHover(true)} onMouseOut={() => setHover(false)}>
            { request.projectType === 'Project' &&
                <FaHammer className='Tile-Image'/>
            }
            { request.projectType === 'Service' &&
                <MdHomeRepairService className='Tile-Image'/>
            }


            <div className='Tile-Information'>
                <div className='Tile-Data' style={{'width':'150px'}}>
                    {`${request.projectType} Request`}
                </div>

                <div className='Tile-Data' style={{'width':'250px'}}>
                    {request.customerName}
                </div>

                <div className='Tile-Data' style={{'width':'250px'}}>
                    {request.name}
                </div>

                {   screenWidth > 1150 &&
                <div className='Tile-Data' style={{'width':'100px'}}>
                    {request.branch}
                </div>
                }

                {   screenWidth > 1400 &&
                <div className='Tile-Data' style={{'width':'180px'}}>
                    {`${request.city}, ${request.state}`}
                </div>
                }

                <div className='Tile-Data' style={{'width':'120px'}}>
                    {organizeDate(request.date)}
                </div>
                {   screenWidth > 1000 &&
                <>
                {hover && <TileHoverPanel request={request} toggleFlag={toggleFlag}/>}
                {!hover &&
                    <div className='Flag-Frame'>
                        {   request.flag &&
                            <FaFlag className='Flag'/>
                        }
                    </div>
                }
                </>
                }
 
            </div>
            
        </div>
    )
};

const EmptyDisplay = () => {
    return(
        <div className='No-Display'>
            No Records to Display.
        </div>
    )
};

const RequestDisplay = ({listObject}) => {
    const { requestList, selectRecord, toggleFlag, screenWidth } = listObject;
    return(
        <div className='Display'> 
            {   requestList &&
                requestList.map((request, key) => (
                    <Tile key={key} request={request} selectRecord={selectRecord} toggleFlag={toggleFlag} screenWidth={screenWidth}/>
                ))
            }
            {   !requestList &&
                <EmptyDisplay />
            }
        </div>
    )
};

const ConfirmationWindow = ({title, confirm, deny}) => {
    return(
        <div className='Vendor-Request-Confirmation-Backdrop'>
            <div className='Vendor-Request-Confirmation'>
                <div className='Vendor-Request-Confirmation-Icon'>
                    <FaFlag />
                </div>
                <div className='Vendor-Request-Confirmation-Header'>
                    {title}
                </div>
                <div className='Vendor-Request-Confirmation-Button-Group'>
                    <button onClick={() => confirm()} className='Vendor-Request-Confirmation-Button Vendor-Request-Confirm-Button'>
                        <FaCheck /> Yes
                    </button>
                    <button onClick={() => deny()} className='Vendor-Request-Confirmation-Button Vendor-Request-Deny-Button'>
                        No
                    </button>
                </div>
            </div>
        </div>
    )
};

const FinalApproveWindow = ({confirm, deny, approvalProps}) => {
    const approveConfirmationTitle = 'Are you sure you want to approve this project request?';
    const [complete,setComplete] = useState(false);

    const checkComplete = () => {
        let complete = true;

        if(!approvalProps.currency) complete=false;

        return complete;
    };

    useEffect(() => {
        if(checkComplete()) setComplete(true);
        else setComplete(false);
    },[approvalProps.currency,]);

    return(
        <div className='Customer-Request-Confirmation-Backdrop'>
            <div className='Customer-Request-Confirmation Customer-Request-Approval-Dialog'>
                <div className='Customer-Request-Confirmation-Icon'>
                    <FaCheckCircle />
                </div>
                <div className='Customer-Request-Confirmation-Header'>
                    {approveConfirmationTitle}
                </div>

                {/* Approval Form Section 
                <div className='Customer-Request-Form-Section'>
                    <div className='Customer-Request-Approval-Grid'>
                        <DropDownSelection title={'Currency'} options={['USD', 'CAD']} setTo={approvalProps.setCurrency} width={150} initializedValue={approvalProps.currency}/>
                    </div>
                </div>
                */}

                <div className='Customer-Request-Confirmation-Button-Group'>
                    {complete ? (
                        <button onClick={() => confirm()} className='Customer-Request-Confirmation-Button Customer-Request-Confirm-Button'>
                            <FaCheck /> Approve
                        </button>
                    ) : (
                        <button disabled className='Customer-Request-Confirmation-Button Customer-Request-Confirm-Button'>
                            Complete Form to Approve
                        </button>
                    )}
                    <button onClick={() => deny()} className='Customer-Request-Confirmation-Button Customer-Request-Deny-Button'>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    )
};

const RecordHeader = ({headerObject}) => {
    const {closeRecord,markInactive,markActive,requestRecord, confirmSelection, openRejection,enterApproval, editRecord, setEditRecord, 
        updateRecord, continueApproving ,projectCreateComplete, approvalFinished} = headerObject;

    const inactiveConfirmationTitle = 'Are you sure you want to mark this project request as inactive?';
    const activeConfirmationTitle = 'Are you sure you want to mark this project request as active?';

    return(
        <div className='Record-Header'>
            {   requestRecord && requestRecord.active && !editRecord && !projectCreateComplete && !approvalFinished &&
                <button onClick={() => enterApproval()} className='Button'>Approve</button>
            }
            {   requestRecord && requestRecord.active && !editRecord && !approvalFinished &&
                <button onClick={() => openRejection()} className='Button'>Reject</button>
            }
            {   requestRecord && projectCreateComplete && !approvalFinished &&
                <button onClick={() => continueApproving()} className='Button'>Continue Approving</button>
            }
            {   requestRecord && requestRecord.active && !editRecord && !approvalFinished &&
                <button onClick={() => confirmSelection(inactiveConfirmationTitle,markInactive)} className='Button'>Mark Processed</button>
            }
            {   requestRecord && !requestRecord.active && !editRecord && !approvalFinished &&
                <button onClick={() => confirmSelection(activeConfirmationTitle,markActive)} className='Button'>Mark Pending</button>
            }
            {   requestRecord && requestRecord.active && !editRecord && !projectCreateComplete && !approvalFinished &&
                <button onClick={() => setEditRecord(true)} className='Button'>Edit</button>
            }
            {   requestRecord && requestRecord.active && editRecord && !projectCreateComplete && !approvalFinished &&
                <button onClick={() => updateRecord(true)} className='Button'>Submit</button>
            }

            <button onClick={() => closeRecord()} className='Button Button-End'>Exit</button>
        </div>
    )
};

const AddressField = ({title,addressObject,editting}) => {
    if(addressObject && !editting){
        return(
            <div className='Record-Form-Field'>
                <div className='Record-Form-Field-Title'>
                    {title}:
                </div>
                <div className='Record-Form-Field-Value'>
                    {`${addressObject.street} ${addressObject.street2 ? addressObject.street2 : ''} ${addressObject.city}, ${addressObject.state} ${addressObject.zip} ${addressObject.country ? addressObject.country : ''}`}
                </div>
            </div>
        )
    }

    if(addressObject && editting){
        return(
            <div className='Record-Form-Field'>
                <div className='Record-Form-Field-Title'>
                    {title}
                </div>
                <div className='Record-Form-Field-Section'>
                    <div className='Record-Form-Under'>
                        <input style={{'width':'200px'}} value={addressObject.street} onChange={e => addressObject.setStreet(e.target.value)} className='Record-Form-Input'/>
                        <div className='Record-Form-Input-Title'>Street:</div>
                    </div>
                    <div className='Record-Form-Under'>
                        <input style={{'width':'120px'}} value={`${addressObject.street2 ? addressObject.street2 : ''}`} onChange={e => addressObject.setStreet2(e.target.value)} className='Record-Form-Input'/>
                        <div className='Record-Form-Input-Title'>Street2:</div>
                    </div>
                    <div className='Record-Form-Under'>
                        <input style={{'width':'150px'}} value={addressObject.city} onChange={e => addressObject.setCity(e.target.value)} className='Record-Form-Input'/>
                        <div className='Record-Form-Input-Title'>City:</div>
                    </div>
                    <div className='Record-Form-Under'>
                        <input style={{'width':'40px'}} value={addressObject.state} onChange={e => addressObject.setState(e.target.value)} className='Record-Form-Input'/>
                        <div className='Record-Form-Input-Title'>State:</div>
                    </div>
                    <div className='Record-Form-Under'>
                        <input style={{'width':'80px'}} value={addressObject.zip} onChange={e => addressObject.setZip(e.target.value)} className='Record-Form-Input'/>
                        <div className='Record-Form-Input-Title'>Zip:</div>
                    </div>
                    <div className='Record-Form-Under'>
                        <input style={{'width':'80px'}} value={addressObject.country} onChange={e => addressObject.setCountry(e.target.value)} className='Record-Form-Input'/>
                        <div className='Record-Form-Input-Title'>Country:</div>
                    </div>
                </div>
            </div>
        )
    }
    else{
        return(
            <>
            </>
        )
    }

};

const RecordField = ({title, value, editting=false, selections=[], setTo, notifier=false, width=250}) => {
    return(
        <div className={`Record-Form-Field ${notifier ? 'notifier' : ''}`}>
            <div className='Record-Form-Field-Title'>
                {title}:
            </div>

            {   !editting &&
            <div className='Record-Form-Field-Value'>
                {value}
            </div>
            }


            {   editting && selections.length < 1 &&
            <input className='Record-Form-Field-Input' style={{'width':`${width}px`}} value={value} onChange={e => setTo(e.target.value)}/>
            }

            {   editting && selections.length > 0 &&
            <select className='Dropdown'onChange={(e) => setTo(e.target.value)}>
                <option value={value}>{value}</option>
                {   selections.map((option, key) => (
                    <option className='Dropdown-Selection' key={key} value={option.value}>{option.text}</option>
                ))
                }
            </select>
            }

        </div>
    )
};

const TextAreaField = ({title, value, editting=false, setTo}) => {
    return(
        <div className='Record-Form-Field'>
            <div className='Record-Form-Field-Title'>
                {title}:
            </div>

            {   !editting &&
            <div className='Record-Form-Field-Value'>
                {value}
            </div>
            }


            {   editting && 
            <textarea className='Record-Form-Field-Input' style={{'width':`600px`,'height':`100px`,'resize':'none'}} value={value} onChange={e => setTo(e.target.value)}/>
            }
        </div>
    )
};

const DateInputField = ({title, value, setTo, editting, width=300}) => {
    return(
        <div className='Record-Form-Field'>
            <div className='Record-Form-Field-Title'>
                {title}:
            </div>
            {   !editting &&
                <div className='Record-Form-Field-Value'>
                    {organizeDate(value)}
                </div>
            }
            {   editting &&
                <input className='Record-Form-Field-Input' type='date' style={{width:`${width}px`}} value={organizeInputDate(value)} onChange={e => setTo(e.target.value)}/>
            }
        </div>
    )
};

const SelectInputField = ({title, value, setTo,editting, options}) => {
    const getTextByValue = (value) => {
        const option = billingOptions.find(option => option.value === value);
        return option ? option.text : null; // Returns the text or null if not found
    };

    return(
        <div className='Record-Form-Field'>          
            <div className='Record-Form-Field-Title'>
                {title}:
            </div>
            { !editting &&
                <div className='Record-Form-Field-Value'>
                    {getTextByValue(value)}
                </div>
            }
            {   editting &&
            <select onChange={e => setTo(e.target.value)} value={value}>
                <option value="" disabled hidden>Select an option</option>
                {   
                options.map((element, key) => (
                    <option key={key} value={element.value}>{element.text}</option>
                ))
                }
            </select>
            }
        </div>
    )
};

const DisplayValueField = ({title, value, width=250, suffix='%'}) => {
    const formatValue = (val) => {
        if (val === null || val === undefined || val === '') return '--';
        if (isNaN(val)) return '--';
        
        const numValue = parseFloat(val);
        if (suffix === '%') {
            return `${numValue.toFixed(2)}${suffix}`;
        }
        return numValue.toFixed(2);
    };

    return(
        <div className='Project-Booking-Input-Field'>
            <div className='Project-Booking-Input-Field-Label'>
                {title}:
            </div>
            <div 
                className='Project-Booking-Display-Value-Field' 
                style={{width: `${width}px`}}
            >
                {formatValue(value)}
            </div>
        </div>
    )
};

const RecordForm = ({formObject}) => {
    const {accessToken,requestRecord, editRecord,customer, setCustomer, customerLocation, setCustomerLocation, projectName, setProjectName,projectType,setProjectType, 
        entityName, setEntityName, poNumber, setPoNumber, projectAddressObject, bondRequired, setBondRequired, businessLicense, setBusinessLicense, 
        ocipCcip, setOcipCcip, ownerDirect, setOwnerDirect, permitsRequired, setPermitsRequired, prevailingWage, setPrevailingWage, contractAmount, setContractAmount, 
        costAmount, setCostAmount, margin, setMargin, retainage, setRetainage, taxStatus, setTaxStatus, notes, setNotes, branch, setBranch, 
        projectManagerString, projectManager, setProjectManager, availableProjectManagers, salesLink, setSalesLink, rejectedRecord, budgetType, estimateNumber, setEstimateNumber, estimateText,
        taskFile,setTaskFile,revenueFile,setRevenueFile,costFile,setCostFile,serviceContracts,updateServiceContract,selectNewCustomer, warrantyPeriod, setWarrantyPeriod, modification, setModification, 
        intercompanyProject, setIntercompanyProject} = formObject;

    const [customerSelected, setCustomerSelected] = useState(null);
    const [locationSelected, setLocationSelected] = useState(null);

    useEffect(() => {
        if(customerSelected && locationSelected) {
            selectNewCustomer(customerSelected,locationSelected);
        };
    },[customerSelected,locationSelected]);

    const openSalesLink = () => {
        const newWindow = window.open(salesLink, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
    };

    const openCustomerLink = () => {
        const newWindow = window.open(customerBaseRoute+customer.customerId, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
    };

    const ProjectRecordField = ({title, value, editting=false, selections=[], setTo, width=250}) => {
        if(value || value === 0 || value === false){
            return(
                <div className='Project-Booking-Record-Form-Field'>
                    <div className='Project-Booking-Record-Form-Field-Title'>
                        {title}
                    </div>
                    <div className='Project-Booking-Record-Form-Field-Value'>
                        {value}
                    </div>
                </div>
            )
        }
        else{
            return(<></>)
        }
    };

    const ProjectAddressField = ({title, addressObject, editting}) => {
        if(addressObject && !editting){
            return(
                <div className='Project-Booking-Record-Form-Field'>
                    <div className='Project-Booking-Record-Form-Field-Title'>
                        {title}
                    </div>
                    <div className='Project-Booking-Record-Form-Field-Value'>
                        {`${addressObject.street}${addressObject.street2 ? `, ${addressObject.street2}` : ''}, ${addressObject.city}, ${addressObject.state} ${addressObject.zip}${addressObject.country ? `, ${addressObject.country}` : ''}`}
                    </div>
                </div>
            )
        }
        else if(addressObject && editting){
            return(                
            <div className='Project-Booking-Record-Form-Field'>
                    <div className='Project-Booking-Record-Form-Field-Title'>
                        {title}
                    </div>
                    <div className='Project-Booking-Record-Form-Field-Value'>
                        <RecordField title={'Street'} value={addressObject.street} editting={editting} setTo={addressObject.setStreet} />
                        <RecordField title={'Street 2'} value={addressObject.street2} editting={editting} setTo={addressObject.setStreet2} />
                        <RecordField title={'City'} value={addressObject.city} editting={editting} setTo={addressObject.setCity} />
                        <RecordField title={'State'} value={addressObject.state} editting={editting} setTo={addressObject.setState} />
                        <RecordField title={'Zip'} value={addressObject.zip} editting={editting} setTo={addressObject.setZip} />
                        <RecordField title={'Country'} value={addressObject.country} editting={editting} setTo={addressObject.setCountry} />
                    </div>
                </div>)
        }
        else{
            return(<></>)
        }
    };

    const ContractField = ({contract, id, editRecord, updateServiceContract}) => {
        const [amount,setAmount] = useState(contract.contractAmount);
        const [startDate,setStartDate] = useState(contract.startDate);
        const [endDate,setEndDate] = useState(contract.endDate);
        const [billingRule,setBillingRule] = useState(contract.billingRule);
        const [presoldHours,setPresoldHours] = useState(contract.presoldHours);
        const [materialAllowance,setMaterialAllowance] = useState(contract.materialAllowance);
        const [travelTime,setTravelTime] = useState(contract.travelTime);
        const [costAmount,setCostAmount] = useState(contract.costAmount);

        const sendUpdate = () => {
            const newContract = {
                id: contract.id,
                billingRule:billingRule,
                contractAmount:amount,
                costAmount: costAmount,
                contractYear:contract.contractYear,
                defaultRetainage:contract.defaultRetainage,
                endDate:endDate,
                margin:contract.margin,
                materialAllowance:materialAllowance,
                presoldHours:presoldHours,
                projectId:contract.projectId,
                startDate:startDate,
                travelTime:travelTime,
            }

            updateServiceContract(newContract,id,'Edit');
        };

        useEffect(() => {
            let changedRecord = false;

            if(amount !== contract.contractAmount) changedRecord = true;
            if(startDate !== contract.startDate) changedRecord = true;
            if(endDate !== contract.endDate) changedRecord = true;
            if(billingRule !== contract.billingRule) changedRecord = true;
            if(presoldHours !== contract.presoldHours) changedRecord = true;
            if(materialAllowance !== contract.materialAllowance) changedRecord = true;
            if(travelTime !== contract.traveltime) changedRecord = true;
            if(costAmount !== contract.costAmount) changedRecord = true;

            if(changedRecord) sendUpdate();
        },[amount,startDate,endDate,billingRule,presoldHours,materialAllowance,travelTime,costAmount]);

        return(
            <div className='Project-Booking-Contract-Section'>
                <div className='Project-Booking-Field-Grid'>
                    <RecordField title={'Contract Year'} value={contract.contractYear}/>
                    <RecordField title={'Amount'} value={amount} editting={editRecord} setTo={setAmount}/>
                    <RecordField title={'Cost Amount'} value={costAmount} editting={editRecord} setTo={setCostAmount}/>
                    <DisplayValueField title={"Margin"} value={((amount - costAmount)/amount)*100} width={150}/>
                    <DateInputField title={'Start Date'} value={startDate} editting={editRecord} setTo={setStartDate}/>
                    <DateInputField title={'End Date'} value={endDate} editting={editRecord} setTo={setEndDate}/>
                    <SelectInputField title={'Billing Rule'} value={billingRule} editting={editRecord} setTo={setBillingRule} options={billingOptions}/>
                    <RecordField title={'Presold Hours'} value={presoldHours} editting={editRecord} setTo={setPresoldHours}/>
                    <RecordField title={'Material Allowance'} value={materialAllowance} editting={editRecord} setTo={setMaterialAllowance}/>
                    <RecordField title={'Travel Time'} value={travelTime} editting={editRecord} setTo={setTravelTime}/>
                </div>
            </div>
        )
    };

    if(requestRecord){
        return(
        <div className='Project-Booking-Record-Form'>
            {/* Request Information Section */}
            <div className='Project-Booking-Form-Section'>
                <div className='Project-Booking-Section-Header'>
                    <h3>Request Information</h3>
                </div>
                <div className='Project-Booking-Section-Content'>
                    <div className='Project-Booking-Field-Grid'>
                        <ProjectRecordField title={'Date Received'} value={organizeDate(requestRecord.date)}/>
                        <ProjectRecordField title={'Submitted By'} value={requestRecord.submitter.name}/>
                        {rejectedRecord && (
                            <ProjectRecordField title={'Rejected On'} value={organizeDate(rejectedRecord.date)}/>
                        )}
                        {rejectedRecord && (
                            <ProjectRecordField title={'Resubmitted On'} value={rejectedRecord.resubmitDate ? organizeDate(rejectedRecord.resubmitDate): '* Not Resubmitted *'}/>
                        )}
                    </div>
                </div>
            </div>

            {/* Project Status Section */}
            {(requestRecord.bookedDate || requestRecord.acumaticaProjectId || requestRecord.serviceContracts || requestRecord.boxFolderId) && (
                <div className='Project-Booking-Form-Section'>
                    <div className='Project-Booking-Section-Header'>
                        <h3>Project Status</h3>
                    </div>
                    <div className='Project-Booking-Section-Content'>
                        <div className='Project-Booking-Field-Grid'>
                            {requestRecord.bookedDate && (
                                <ProjectRecordField title={'Project Booked On'} value={organizeDate(requestRecord.bookedDate)}/>
                            )}
                            {requestRecord.completeDate && (
                                <ProjectRecordField title={'Project Booking Finalized On'} value={organizeDate(requestRecord.completeDate)}/>
                            )}
                            {requestRecord.bookedDate && !requestRecord.completeDate && (
                                <ProjectRecordField title={'Project Booking Finalized On'} value={'* Project Booking Not Finalized *'}/>
                            )}
                            {requestRecord.acumaticaProjectId && (
                                <ProjectRecordField title={'Acumatica Project ID'} value={requestRecord.acumaticaProjectId}/>
                            )}
                            {requestRecord.boxFolderId && (
                                <ProjectRecordField title={'Box Folder ID'} value={requestRecord.boxFolderId}/>
                            )}
                        </div>
                        {requestRecord.serviceContracts && requestRecord.serviceContracts.map((contract,id) => (
                            <ProjectRecordField key={id} title={`Acumatica Service Contract Year ${id+1}`} value={contract}/>
                        ))}
                    </div>
                </div>
            )}

            {/* Customer Information Section */}
            <div className='Project-Booking-Form-Section'>
                <div className='Project-Booking-Section-Header'>
                    <h3>Customer Information</h3>
                </div>
                <div className='Project-Booking-Section-Content'>
                    {!editRecord && (
                        <>
                            <div className='Project-Booking-Field-Grid'>
                                <ProjectRecordField title={'Customer ID'} value={customer.customerId}/>
                                <ProjectRecordField title={'Customer Name'} value={customer.name}/>
                                <ProjectRecordField title={'Customer Class'} value={customer.class}/>
                                <ProjectRecordField title={'Customer Location ID'} value={customerLocation.locationId}/>
                                <ProjectRecordField title={'Customer Location Name'} value={customerLocation.name}/>
                            </div>
                            <ProjectAddressField title={'Customer Location Address'} addressObject={customerLocation.address}/>
                            <button className='Project-Booking-Sales-Link' onClick={() => openCustomerLink()}>
                                Customer Record Link
                            </button>
                        </>
                    )}
                    {editRecord && (
                        <CustomerSelector 
                            apiToken={accessToken} 
                            customerSelected={customerSelected} 
                            setCustomerSelected={setCustomerSelected} 
                            locationSelected={locationSelected} 
                            setLocationSelected={setLocationSelected} 
                            title={false}
                        />
                    )}
                </div>
            </div>

            {/* Project Details Section */}
            <div className='Project-Booking-Form-Section'>
                <div className='Project-Booking-Section-Header'>
                    <h3>Project Details</h3>
                </div>
                <div className='Project-Booking-Section-Content'>
                    <div className='Project-Booking-Field-Grid'>
                        <RecordField title={'Request Type'} value={projectType} editting={editRecord} selections={requestTypeOptions} setTo={setProjectType}/>
                        <RecordField title={'Project Name'} value={projectName} editting={editRecord} setTo={setProjectName}/>
                        <RecordField title={'Entity Name'} value={entityName} editting={editRecord} setTo={setEntityName}/>
                        <RecordField title={'PO Number'} value={poNumber} editting={editRecord} setTo={setPoNumber}/>
                        <RecordField title={'Branch'} value={branch} editting={editRecord} selections={branchOptions} setTo={setBranch}/>
                        <RecordField title={'Project Manager'} value={projectManagerString} editting={editRecord} selections={availableProjectManagers} setTo={setProjectManager}/>
                    </div>
                    <ProjectAddressField title={'Project Address'} addressObject={projectAddressObject} editting={editRecord}/>
                </div>
            </div>

            {/* Project Requirements Section */}
            <div className='Project-Booking-Form-Section'>
                <div className='Project-Booking-Section-Header'>
                    <h3>Project Requirements</h3>
                </div>
                <div className='Project-Booking-Section-Content'>
                    <div className='Project-Booking-Field-Grid'>
                        <RecordField title={'Bonding Required'} value={bondRequired === 'true' ? 'Yes' : 'No'} editting={editRecord} selections={trueOrFalseOptions} setTo={setBondRequired}/>
                        <RecordField title={'Business License Required'} value={businessLicense === 'true' ? 'Yes' : 'No'} editting={editRecord} selections={trueOrFalseOptions} setTo={setBusinessLicense}/>
                        <RecordField title={'Certified Payroll / Prevailing Wage'} value={prevailingWage === 'true' ? 'Yes' : 'No'} editting={editRecord} selections={trueOrFalseOptions} setTo={setPrevailingWage}/>
                        <RecordField title={'Permits Required'} value={permitsRequired === 'true' ? 'Yes' : 'No'} editting={editRecord} selections={trueOrFalseOptions} setTo={setPermitsRequired}/>
                        <RecordField title={'Tax Status'} value={taxStatus} editting={editRecord} selections={taxabilityOptions} setTo={setTaxStatus} notifier={taxStatus === 'Other' ? true : false}/>
                        {projectType === 'Project' && (
                            <>
                                <RecordField title={'Intercompany Project'} value={intercompanyProject === 'true' ? 'Yes' : 'No'} editting={editRecord} selections={trueOrFalseOptions} setTo={setIntercompanyProject}/>
                                <RecordField title={'Owner Direct Purchase'} value={ownerDirect === 'true' ? 'Yes' : 'No'} editting={editRecord} selections={trueOrFalseOptions} setTo={setOwnerDirect} notifier={ownerDirect === 'true' ? true : false}/>
                                <RecordField title={'CCIP / OCIP'} value={ocipCcip === 'true' ? 'Yes' : 'No'} editting={editRecord} selections={trueOrFalseOptions} setTo={setOcipCcip}/>
                                <RecordField title={'Warranty Period (Months)'} value={warrantyPeriod} editting={editRecord} setTo={setWarrantyPeriod}/>
                                {   projectAddressObject.state === 'AZ' &&
                                    <RecordField title={'Modification'} value={modification === 'true' ? 'Yes' : 'No'} editting={editRecord} selections={trueOrFalseOptions} setTo={setModification}/>
                                }
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Financial Information Section */}
            <div className='Project-Booking-Form-Section'>
                <div className='Project-Booking-Section-Header'>
                    <h3>Financial Details</h3>
                </div>
                <div className='Project-Booking-Section-Content'>
                    {projectType === 'Project' && (
                        <div className='Project-Booking-Field-Grid'>
                            <RecordField title={'Total Contract Value'} value={contractAmount} editting={editRecord} setTo={setContractAmount}/>
                            <RecordField title={'Estimated Costs'} value={costAmount} editting={false} setTo={setCostAmount}/>
                            <RecordField title={'Margin (Percentage)'} value={margin} setTo={setMargin}/>
                            <RecordField title={'Retainage (Percentage)'} value={retainage} editting={editRecord} setTo={setRetainage}/>
                        </div>
                    )}
                    {projectType === 'Service' && serviceContracts && serviceContracts.length > 0 && (
                        <div>
                            {serviceContracts.map((contract, key) => (
                                <ContractField contract={contract} id={key} key={key} editRecord={editRecord} updateServiceContract={updateServiceContract}/>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            {/* Sales and Budget Section */}
            <div className='Project-Booking-Form-Section'>
                <div className='Project-Booking-Section-Header'>
                    <h3>Sales and Budget Information</h3>
                </div>
                <div className='Project-Booking-Section-Content'>
                    <div className='Project-Booking-Field-Grid'>
                        {budgetType && (
                            <TextAreaField title={'Type of Budget'} value={budgetType}/>
                        )}
                        {budgetType === 'ProEst' && estimateNumber && !editRecord && (
                            <ProjectRecordField title={'ProEst Estimate Number'} value={estimateNumber}/>
                        )}
                        {budgetType === 'ProEst' && editRecord && (
                            <RecordField title={'ProEst Estimate Number'} value={estimateNumber} editting={editRecord} setTo={setEstimateNumber}/>
                        )}
                        {budgetType === 'Sage' && estimateNumber && !editRecord && (
                            <RecordField title={'Sage Estimate Number'} value={estimateNumber}/>
                        )}
                        {budgetType === 'Sage' && editRecord && (
                            <RecordField title={'Sage Estimate Number'} value={estimateNumber} editting={editRecord} setTo={setEstimateNumber}/>
                        )}
                        {budgetType === 'None' && estimateText && (
                            <TextAreaField title={'Reason for skipping budget'} value={estimateText}/>
                        )}
                    </div>

                    {editRecord && (
                        <RecordField title={'Sales Link'} value={salesLink} editting={editRecord} setTo={setSalesLink} width={600}/>
                    )}
                    {!editRecord && salesLink && (
                        <button className='Project-Booking-Sales-Link' onClick={() => openSalesLink()}>
                            Sales Folder Link
                        </button>
                    )}

                    {budgetType === 'Standard' && requestRecord.budget.taskFileName && (
                        <>
                            <div className='Project-Booking-Budget-Files'>
                                <button className='Project-Booking-Sales-Link' onClick={() => openProjectBookingTask(accessToken,requestRecord.budget.taskFileName)}>
                                    Download Tasks
                                </button>
                                <button className='Project-Booking-Sales-Link' onClick={() => openProjectBookingRevenue(accessToken,requestRecord.budget.revenueFileName)}>
                                    Download Revenue Budget
                                </button>
                                <button className='Project-Booking-Sales-Link' onClick={() => openProjectBookingCost(accessToken,requestRecord.budget.costFileName)}>
                                    Download Cost Budget
                                </button>
                            </div>
                            {editRecord && (
                                <div className='Record-Budget-File-Uploads'>
                                    <div className='Record-Budget-File-Upload'>
                                        <div className='Record-Budget-File-Title'>Update Cost File</div>
                                        <input type='file' accept=".xls,.xlsx" onChange={(e) => setCostFile(e.target.files)} className='Record-Budget-File-Input'/>
                                    </div>
                                </div>
                            )}
                        </>
                    )}

                    {budgetType === 'ProEst' && estimateNumber && !editRecord && (
                        <button className='Project-Booking-Sales-Link' onClick={() => openProestBudgetLink(estimateNumber)}>
                            ProEst Estimate Link
                        </button>
                    )}
                </div>
            </div>

            {/* Notes Section */}
            <div className='Project-Booking-Form-Section'>
                <div className='Project-Booking-Section-Header'>
                    <h3>Additional Notes</h3>
                </div>
                <div className='Project-Booking-Section-Content'>
                    <TextAreaField title={'Notes'} value={notes} editting={editRecord} setTo={setNotes}/>
                </div>
            </div>
        </div>
    )
    } else return(<></>)
};

const RecordFile = ({fileName, selectionTitle, id, selectPdf, fileType}) => {
    return(
        <div className='Project-Booking-Record-File' onClick={() => selectPdf(selectionTitle, id)}>
            <div className='Project-Booking-File-Icon-Container'>
                <FaFilePdf className='Project-Booking-Record-File-Image'/>
            </div>
            <div className='Project-Booking-File-Info'>
                <div className='Project-Booking-File-Type'>{fileType}</div>
                <div className='Project-Booking-Record-File-Name'>
                    {fileName}
                </div>
            </div>
        </div>
    )
};

const RecordFiles = ({requestRecord, selectPdf}) => {
    const getFileTypeLabel = (fileName, defaultType) => {
        if (fileName && fileName.toLowerCase().includes('contract')) return 'Contract Document';
        if (fileName && fileName.toLowerCase().includes('ocip')) return 'Insurance Program';
        if (fileName && fileName.toLowerCase().includes('bond')) return 'Bonding Document';
        if (fileName && fileName.toLowerCase().includes('rate')) return 'Prevailing Wage';
        if (fileName && fileName.toLowerCase().includes('tax')) return 'Tax Exemption';
        return defaultType || 'Document';
    };

    const files = [
        requestRecord.contractFile && {
            fileName: requestRecord.contractFile,
            selectionTitle: 'Contract',
            id: requestRecord.contract,
            type: 'Contract Document'
        },
        requestRecord.ocipFile && {
            fileName: requestRecord.ocipFile,
            selectionTitle: 'Ocip',
            id: requestRecord.ocip,
            type: 'Insurance Program'
        },
        requestRecord.bondingFile && {
            fileName: requestRecord.bondingFile,
            selectionTitle: 'Bonding',
            id: requestRecord.bonding,
            type: 'Bonding Document'
        },
        requestRecord.rateSheetFile && {
            fileName: requestRecord.rateSheetFile,
            selectionTitle: 'Prevailing Wage',
            id: requestRecord.rateSheet,
            type: 'Prevailing Wage'
        },
        requestRecord.taxExemptionFile && {
            fileName: requestRecord.taxExemptionFile,
            selectionTitle: 'Tax Exemption',
            id: requestRecord.taxExemption,
            type: 'Tax Exemption'
        },
        requestRecord.financialTabFile && {
            fileName: requestRecord.financialTabFile,
            selectionTitle: 'Financial Tab',
            id: requestRecord.financialTab,
            type: 'Financial Tab'
        }
    ].filter(Boolean);

    return(
        <div className='Project-Booking-Record-Files'>
            <div className='Project-Booking-Record-Files-Header'>
                <div className='Project-Booking-Record-Files-Title'>
                    <FaFilePdf className='Project-Booking-Files-Icon' />
                    Attached Files
                </div>
                <div className='Project-Booking-Files-Count'>
                    {files.length} file{files.length !== 1 ? 's' : ''}
                </div>
            </div>
            
            <div className='Project-Booking-Record-Files-List'>
                {files.length > 0 ? (
                    files.map((file, index) => (
                        <RecordFile 
                            key={index}
                            fileName={file.fileName} 
                            selectionTitle={file.selectionTitle} 
                            id={file.id} 
                            selectPdf={selectPdf}
                            fileType={file.type}
                        />
                    ))
                ) : (
                    <div className='Project-Booking-Files-Empty'>
                        <FaFilePdf className='Project-Booking-Files-Empty-Icon' />
                        <div className='Project-Booking-Files-Empty-Text'>
                            No files attached
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
};

const RecordPdfViewer = ({closePdf,selectedPdf}) => {
    return(
        <div className='Record-Pdf-Viewer-Window' onClick={() => closePdf()}>

            <div className='Record-Pdf-Viewer'>
                {   selectedPdf &&
                <object data={`data:application/pdf;base64,${selectedPdf}`} type="application/pdf" width="100%" height="100%">
                    <p>Failed to Load PDF</p>
                </object>
                }
            </div>
        </div>
    )
};

const RejectionSection = ({setTo, title}) => {
    return(
        <div className='Rejection-Section'>
            <input type='checkbox' className='Rejection-Section-Button' onClick={e => setTo(e.target.checked)}/>
            <div className='Rejection-Section-Title'>
                {title}
            </div>
        </div>
    )
};

const RejectionWindow = ({closeRejection, confirmReject,setRejectionText}) => {
    return(
        <div className='Vendor-Request-Confirmation-Backdrop'>
            <div className='Vendor-Request-Rejection-Window'>
                <div className='Vendor-Request-Confirmation-Icon'>
                    <FaFlag />
                </div>
                <div className='Vendor-Request-Confirmation-Header'>
                    Please enter a reason for rejecting this project request.
                </div>

                <textarea 
                    className='Vendor-Request-Rejection-Text' 
                    cols="50" 
                    rows="10" 
                    placeholder="Enter rejection reason..."
                    onChange={e => setRejectionText(e.target.value)}
                />

                <div className='Vendor-Request-Confirmation-Button-Group'>
                    <button onClick={() => confirmReject()} className='Vendor-Request-Confirmation-Button Vendor-Request-Confirm-Button'>
                        <FaFlag /> Confirm Rejection
                    </button>
                    <button onClick={() => closeRejection()} className='Vendor-Request-Confirmation-Button Vendor-Request-Deny-Button'>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    )
};

const RecordWindow = ({recordObject,accessToken}) => {
    const { requestRecord,setRequestRecord,closeRecord,markInactive,markActive,approveRecord, rejectRecord,rejectedRecord,serviceContracts,
        updateServiceContract,projectCreateComplete,continueApproving,approvalFinished} = recordObject
    const [ confirmWindow, setConfirmWindow ] = useState(false);
    const [ approvalWindow, setApprovalWindow] = useState(false);
    const [ confirmText, setConfirmText ] = useState('');
    const [ callAfterFunction, setCallAfterFunction ] = useState();
    const [ pdfViewer, setPdfViewer ] = useState(false);
    const [ selectedPdf, setSelectedPdf ] = useState();

    const [ rejecting, setRejecting ] = useState(false);
    const [ rejectionText, setRejectionText ] = useState('');
    const [ rejectionSections, setRejectionSections ] = useState([]);

    const [currency, setCurrency] = useState('USD');

    const [ editRecord, setEditRecord ] = useState(false);

    const [customer, setCustomer] = useState({});
    const [customerLocation, setCustomerLocation] = useState({});
    const [projectName, setProjectName] = useState('');
    const [projectType, setProjectType] = useState('');
    const [entityName, setEntityName] = useState('');
    const [poNumber, setPoNumber] = useState('');
    const [street, setStreet] = useState('');
    const [street2, setStreet2] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zip, setZip] = useState('');
    const [country, setCountry] = useState('');

    const [bondRequired, setBondRequired] = useState(false);
    const [businessLicense, setBusinessLicense] = useState(false);
    const [ocipCcip, setOcipCcip] = useState('');
    const [ownerDirect, setOwnerDirect] = useState(false);
    const [prevailingWage, setPrevailingWage] = useState(false);
    const [permitsRequired, setPermitsRequired] = useState(false);
    const [modification, setModification] = useState(false);
    const [warrantyPeriod, setWarrantyPeriod] = useState(0);
    const [intercompanyProject, setIntercompanyProject] = useState(false);

    const [contractAmount, setContractAmount] = useState(0);
    const [costAmount, setCostAmount] = useState(0);
    const [margin, setMargin] = useState(0);
    const [retainage, setRetainage] = useState(0);
    const [taxStatus, setTaxStatus] = useState('');

    const [serviceContractsUpdated, setServiceContractsUpdated] = useState(false);
    const [serviceContractsupdatedError, setServiceContractsupdatedError] = useState('');

    const [budgetType, setBudgetType] = useState('');
    const [estimateNumber, setEstimateNumber] = useState('');
    const [estimateText,setEstimateText] = useState('');

    const [taskFile, setTaskFile] = useState();
    const [taskFileId, setTaskFileId] = useState();
    const [revenueFile, setRevenueFile] = useState();
    const [revenueFileId, setRevenueFileId] = useState();
    const [costFile, setCostFile] = useState();
    const [costFileId, setCostFileId] = useState();


    
    const [notes, setNotes] = useState('');

    const [branch, setBranch] = useState('');
    const [projectManagerString, setProjectManagerString] = useState('');
    const [projectManager, setProjectManager] = useState('');
    const [availableProjectManagers, setAvailableProjectManagers] = useState([]);
    const [availableProjectManagersError, setAvailableProjectManagersError] = useState('');
    const [salesLink, setSalesLink] = useState('');

    const [submitting, setSubmitting] = useState(false);

    const approvalProps = {
        currency: currency,
        setCurrency: setCurrency,
    };

    useEffect(() => {
        getFilteredProjectManagers(accessToken,branch,setAvailableProjectManagers,setAvailableProjectManagersError);
    },[branch]);

    useEffect(() => {
        if(contractAmount > 0 && costAmount > 0){
            let result = (((contractAmount-costAmount)/contractAmount)*100);
            setMargin(result.toFixed(2));
        }
        else setMargin(0);
    },[contractAmount,costAmount]);

    useEffect(() => {
        availableProjectManagers.forEach(element => {
            if(element.value === projectManager){
                setProjectManagerString(element.text);
            };
        });
    },[availableProjectManagers,projectManager]);

    useEffect(() => {
        if(requestRecord){
            setCustomer(requestRecord.customer);
            setCustomerLocation(requestRecord.customer.location);
            setProjectName(requestRecord.name);
            if(requestRecord.entityName) setEntityName(requestRecord.entityName);
            else setEntityName('* Same as Customer *');
            if(requestRecord.poNumber) setPoNumber(requestRecord.poNumber);
            else setPoNumber('* None Provided *');
            setWarrantyPeriod(requestRecord.warrantyPeriod ? requestRecord.warrantyPeriod : 0);
            setProjectType(requestRecord.projectType);
            setStreet(requestRecord.address.street);
            setStreet2(requestRecord.address.street2);
            setCity(requestRecord.address.city);
            setState(requestRecord.address.state);
            setZip(requestRecord.address.zip);
            setBondRequired(requestRecord.bondRequired ? 'true' : 'false');
            setBusinessLicense(requestRecord.businessLicense ? 'true' : 'false');
            setOcipCcip(requestRecord.ccipInsturance ? 'true' : 'false');
            setOwnerDirect(requestRecord.ownerDirect ? 'true' : 'false');
            setPermitsRequired(requestRecord.permitsRequired ? 'true' : 'false');
            setIntercompanyProject(requestRecord.intercompanyProject ? 'true' : 'false');
            setModification(requestRecord.modification ? 'true' : 'false');
            setPrevailingWage(requestRecord.prevailingWage ? 'true' : 'false');
            setContractAmount(requestRecord.contractAmount);
            setCostAmount(requestRecord.costAmount);
            setMargin(requestRecord.margin);
            setRetainage(requestRecord.defaultRetainage);
            setTaxStatus(requestRecord.taxStatus);
            if(requestRecord.notes) setNotes(requestRecord.notes);
            else setNotes('* None *');
            setBranch(requestRecord.branch);
            setProjectManager(requestRecord.projectManager);
            setSalesLink(requestRecord.salesLink);
            if(requestRecord.budget){
                setBudgetType(requestRecord.budget.type);
                setEstimateNumber(requestRecord.budget.estimateNumber);
                setEstimateText(requestRecord.budget.text);
            }
        };
    },[requestRecord]);

    const selectNewCustomer = (newCustomer,newLocation) => {  
        let updatedCustomer = customer;
        updatedCustomer.class = newCustomer.class;
        updatedCustomer.customerId = newCustomer.customerId;
        updatedCustomer.name = newCustomer.name;
        setCustomer(updatedCustomer);

        let updatedLocation = customerLocation;
        updatedLocation.locationId = newLocation.locationID;
        updatedLocation.name = newLocation.locationName;
        updatedLocation.address.street = newLocation.address.street;
        updatedLocation.address.street2 = newLocation.address.street2;
        updatedLocation.address.city = newLocation.address.city;
        updatedLocation.address.state = newLocation.address.state;
        updatedLocation.address.zip = newLocation.address.zip;
        updatedLocation.address.country = newLocation.address.country;
        setCustomerLocation(updatedLocation);
    };

    const createRecordObject = () => {
        let updatedRecord = requestRecord;
        
        updatedRecord.customer = customer;
        updatedRecord.customer.location = customerLocation;
        updatedRecord.projectName = projectName.replace(/[^a-zA-Z0-9\s]/g, '');
        updatedRecord.projectType = projectType;
        if(entityName !== '* Same as Customer *') updatedRecord.entityName = entityName.replace(/[^a-zA-Z0-9\s]/g, '');
        else updatedRecord.entityName = null
        if(poNumber !== '* None Provided *') updatedRecord.customerPoNumber = poNumber.replace(/[^a-zA-Z0-9\s]/g, '');
        else updatedRecord.customerPoNumber = null;
        updatedRecord.address.street = street.replace(/[^a-zA-Z0-9\s]/g, '');
        if(street2) updatedRecord.address.street2 = street2.replace(/[^a-zA-Z0-9\s]/g, '');
        else updatedRecord.address.street2 = null;
        updatedRecord.address.city = city.replace(/[^a-zA-Z0-9\s]/g, '');
        updatedRecord.address.state = state.replace(/[^a-zA-Z0-9\s]/g, '');
        updatedRecord.address.zip = zip.replace(/[^a-zA-Z0-9\s]/g, '');
        updatedRecord.address.country = country.replace(/[^a-zA-Z0-9\s]/g, '');
        updatedRecord.bondRequired = bondRequired === 'true' ? true : false;
        updatedRecord.businessLicenseRequired = businessLicense === 'true' ? true : false;
        updatedRecord.ownerDirectPurchase = ownerDirect === 'true' ? true : false;
        updatedRecord.prevailingWage = prevailingWage === 'true' ? true : false;
        updatedRecord.intercompanyProject = intercompanyProject === 'true' ? true : false;
        updatedRecord.permitsRequired = permitsRequired === 'true' ? true : false;
        updatedRecord.modification = modification === 'true' ? true : false;
        updatedRecord.warrantyPeriod = warrantyPeriod ? parseInt(warrantyPeriod) : 0;
        updatedRecord.ccipInsurance = ocipCcip;
        updatedRecord.totalContractAmount = contractAmount;
        updatedRecord.totalCostAmount = costAmount;
        updatedRecord.margin = margin;
        updatedRecord.defaultRetainage = retainage;
        updatedRecord.taxStatus = taxStatus;
        if(notes !== '* None *') updatedRecord.notes = notes.replace(/[^a-zA-Z0-9\s]/g, '');
        else updatedRecord.notes = null;
        updatedRecord.branch = branch;
        updatedRecord.projectManager = projectManager;
        updatedRecord.salesLink = salesLink;
        updatedRecord.budget.type = budgetType;
        updatedRecord.budget.estimateNumber = estimateNumber;
        updatedRecord.serviceContractList = serviceContracts;

        if(taskFileId) updatedRecord.budget.taskFileName = taskFileId;
        if(revenueFileId) updatedRecord.budget.revenueFileName = revenueFileId;
        if(costFileId) updatedRecord.budget.costFileName = costFileId;

        return updatedRecord;
    };

    useEffect(() => {
        let ready = true;

        if(!submitting) ready = false;
        if(taskFile && !taskFileId) ready = false;
        if(revenueFile && !revenueFileId) ready = false;
        if(costFile && !costFileId) ready = false;

        if(ready) finalUpdate();

    },[taskFileId,revenueFileId,costFileId]);

    const finalUpdate = async () => {
        const updatedRecord = createRecordObject();
        newProjectBookingDataService.updateRecord(accessToken,updatedRecord).then(res => {
            if(res.data.id){
                setEditRecord(false);
                recordObject.selectRecord(res.data.id);
            };  
        });
    };

    const updateRecord = async () => {
        setSubmitting(true);

        if(taskFile) await newProjectBookingDataService.updateProjectBookingTask(accessToken,taskFile[0],requestRecord.name).then(res => setTaskFileId(res.data.fileName));
        if(revenueFile) await newProjectBookingDataService.updateProjectBookingRevenue(accessToken,revenueFile[0],requestRecord.name).then(res => {setRevenueFileId(res.data.fileName)});
        if(costFile) await newProjectBookingDataService.updateProjectBookingCost(accessToken,costFile[0],requestRecord.name).then(res => setCostFileId(res.data.fileName));

        if(!taskFile && !revenueFile && !costFile ) finalUpdate();
    };

    const getContract = async (id) => {
        setPdfViewer(true);
        const file = await newProjectBookingDataService.getContract(accessToken,id);
        setSelectedPdf(file);
    };

    const getOcip = async (id) => {
        setPdfViewer(true);
        const file = await newProjectBookingDataService.getOcip(accessToken,id);
        setSelectedPdf(file);
    };

    const getPrevailing = async (id) => {
        setPdfViewer(true);
        const file = await newProjectBookingDataService.getPrevailing(accessToken,id);
        setSelectedPdf(file);
    };

    const getTaxExemption = async (id) => {
        setPdfViewer(true);
        const file = await newProjectBookingDataService.getTaxExemption(accessToken,id);
        setSelectedPdf(file);
    };

    const getBonding = async (id) => {
        setPdfViewer(true);
        const file = await newProjectBookingDataService.getBonding(accessToken,id);
        setSelectedPdf(file);
    };

    const getFinancialTab = async (fileName) => {
        const file = await newProjectBookingDataService.getFinancialTab(accessToken,fileName);
    };

    const closePdf = () => {
        setPdfViewer(false);
        setSelectedPdf(null);
    };

    const selectPdf = (selection, id) => {
        if(selection === 'Contract') getContract(id);
        if(selection === 'Ocip') getOcip(id);
        if(selection === 'Prevailing Wage') getPrevailing(id);
        if(selection === 'Tax Exemption') getTaxExemption(id);
        if(selection === 'Bonding') getBonding(id);
        if(selection === 'Financial Tab') getFinancialTab(requestRecord.financialTabFile);
    };

    const denySelection = () => {
        setConfirmText('');
        setConfirmWindow(false);
    };

    const approve = () => {
        approveRecord(currency);
    };

    const approveSelection = () => {
        setConfirmText('');
        setConfirmWindow(false);
        callAfterFunction();
    };

    const closeRejection = () => {
        setRejecting(false);
    };

    const confirmReject = () => {
        rejectRecord(rejectionText,closeRejection);
    };

    const openRejection = () => {
        setRejecting(true);
    };

    const exitApproval = () => {
        setApprovalWindow(false);
    };

    const enterApproval = () => {
        setApprovalWindow(true);
    };

    const confirmSelection = (text,confirmFunction) => {
        setConfirmText(text);
        setConfirmWindow(true);
        setCallAfterFunction(() => confirmFunction);
    };

    const headerObject = {
        requestRecord:requestRecord,
        closeRecord:closeRecord,
        markInactive:markInactive,
        markActive:markActive,
        confirmSelection:confirmSelection,
        approveRecord:approveRecord,
        openRejection:openRejection,
        editRecord:editRecord,
        setEditRecord:setEditRecord,
        updateRecord:updateRecord,
        enterApproval:enterApproval,
        projectCreateComplete:projectCreateComplete,
        continueApproving:continueApproving,
        approvalFinished:approvalFinished,
    };

    const projectAddressObject = {
        street: street,
        setStreet: setStreet,
        street2: street2,
        setStreet2: setStreet2,
        city: city,
        setCity: setCity,
        state: state,
        setState: setState,
        zip: zip,
        setZip: setZip,
        country: country,
        setCountry: setCountry,
    };
    
    const formObject = {
        accessToken:accessToken,
        requestRecord:requestRecord,
        editRecord:editRecord,
        customer: customer,
        setCustomer: setCustomer,
        customerLocation: customerLocation,
        setCustomerLocation: setCustomerLocation,
        projectName: projectName,
        setProjectName: setProjectName,
        projectType:projectType,
        setProjectType:setProjectType,
        projectAddressObject:projectAddressObject,
        entityName: entityName,
        setEntityName: setEntityName,
        poNumber: poNumber,
        setPoNumber: setPoNumber,
        warrantyPeriod: warrantyPeriod,
        setWarrantyPeriod: setWarrantyPeriod,
        bondRequired: bondRequired,
        setBondRequired: setBondRequired,
        businessLicense: businessLicense,
        setBusinessLicense: setBusinessLicense,
        ocipCcip: ocipCcip,
        setOcipCcip: setOcipCcip,
        ownerDirect: ownerDirect,
        setOwnerDirect: setOwnerDirect,
        permitsRequired: permitsRequired,
        setPermitsRequired: setPermitsRequired,
        intercompanyProject: intercompanyProject,
        setIntercompanyProject: setIntercompanyProject,
        modification: modification,
        setModification: setModification,
        prevailingWage: prevailingWage,
        setPrevailingWage: setPrevailingWage,
        contractAmount: contractAmount,
        setContractAmount: setContractAmount,
        costAmount: costAmount,
        setCostAmount: setCostAmount,
        margin: margin,
        setMargin: setMargin,
        retainage:retainage,
        setRetainage:setRetainage,
        taxStatus: taxStatus,
        setTaxStatus: setTaxStatus,
        notes: notes,
        setNotes: setNotes,
        branch:branch,
        setBranch,setBranch,
        projectManagerString,projectManagerString,
        projectManager: projectManager,
        setProjectManager: setProjectManager,
        availableProjectManagers:availableProjectManagers,
        salesLink: salesLink,
        setSalesLink: setSalesLink,
        rejectedRecord:rejectedRecord,
        budgetType:budgetType,
        estimateNumber:estimateNumber,
        setEstimateNumber:setEstimateNumber,
        estimateText:estimateText,
        taskFile:taskFile,
        setTaskFile:setTaskFile,
        revenueFile:revenueFile,
        setRevenueFile:setRevenueFile,
        costFile:costFile,
        setCostFile:setCostFile,
        serviceContracts:serviceContracts,
        updateServiceContract:updateServiceContract,
        selectNewCustomer:selectNewCustomer,
    };

    return(
        <div className='Record-Window'>
            {   rejecting &&
                <RejectionWindow closeRejection={closeRejection} confirmReject={confirmReject} setRejectionText={setRejectionText}/>
            }
            {   !confirmWindow && !approvalWindow && !rejecting &&
            <>
                <RecordHeader headerObject={headerObject}/>
                <div className='Project-Booking-Record-Content'>
                    <div className='Project-Booking-Record-Main'>
                        {requestRecord && (
                            <RecordForm formObject={formObject}/>
                        )}
                    </div>
                    <div className='Project-Booking-Record-Sidebar'>
                        {requestRecord && (
                            <RecordFiles requestRecord={requestRecord} selectPdf={selectPdf}/>
                        )}
                    </div>
                </div>
            </>
            }
            {   approvalWindow &&
                <FinalApproveWindow title={confirmText} confirm={approve} deny={exitApproval} approvalProps={approvalProps}/>
            }
            {   confirmWindow && 
                <ConfirmationWindow title={confirmText} confirm={approveSelection} deny={denySelection}/>
            }
            {   pdfViewer &&
                <RecordPdfViewer closePdf={closePdf} selectedPdf={selectedPdf}/>
            }
        </div>
    );
};

const Loader = () => {
    return (
      <RotatingLines
        strokeColor="rgb(6, 89, 79)"
        strokeWidth="5"
        animationDuration="0.75"
        width="96"
        visible={true}
      />
    )
};

const ApprovalWindow = ({accessToken,approvalFinished,projectCreateComplete,projectAlreadyCreated,boxLink,acumaticaLink,budgetCreateComplete,
    setBudgetCreateComplete,budgetAlreadyCreated,budget,serviceContractsRequired,goBackToReview,bookedServiceContracts,finalizeProjectBooking,markInactive,formatExport,updatingBudget}) => {
    const [ closingProjectCreate, setClosingProjectCreate ] = useState(projectAlreadyCreated);
    const [ closingBudgetSubmit, setClosingBudgetSubmit] = useState(budgetAlreadyCreated);

    const [ budgetExport, setBudgetExport ] = useState();

    useEffect(() => {
        if(projectCreateComplete){
            setTimeout(() => {
                setClosingProjectCreate(true);
            },1000)};
    },[projectCreateComplete]);

    useEffect(() => {
        if(budgetCreateComplete){
            setTimeout(() => {
                setClosingBudgetSubmit(true);
            },1000)};
    },[budgetCreateComplete]);

    useEffect(() => {
        if(approvalFinished) setTimeout(() => {
            markInactive();
        },1000);
    },[approvalFinished]);

    const openProjectLink = () => {
        const newWindow = window.open(acumaticaLink, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
    };

    const openStandardBudgetInstructions = () => {
        const newWindow = window.open(standardBudgetUploadInstructions, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
    };

    const openProEstBudgetInstructions = () => {
        const newWindow = window.open(proestBudgetUploadInstructions, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
    };

    const openSageBudgetInstructions = () => {
        const newWindow = window.open(sageBudgetUploadInstructions, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
    };

    const formatBudgetExport = () => {
        formatExport(budgetExport);
        setBudgetExport(null);
    };

    const BudgetInputWindow = ()  => {
        if(budget.type === 'Standard') return(
            <div className='Modern-Budget-Section'>
                <div className='Modern-Budget-Header'>
                    <div className='Modern-Budget-Icon-Container'>
                        <FaFileUpload className='Modern-Budget-Icon' />
                    </div>
                    <div className='Modern-Budget-Header-Content'>
                        <h3 className='Modern-Budget-Title'>Standard Budget Upload</h3>
                        <p className='Modern-Budget-Subtitle'>Download and upload budget files to complete project setup</p>
                    </div>
                </div>

                <div className='Modern-Budget-Instructions'>
                    <p>Download the task, revenue, and cost files below and upload them into the project.</p>
                    
                    <button 
                        className='Modern-Budget-Instructions-Link' 
                        onClick={() => openStandardBudgetInstructions()}
                    >
                        <FaExternalLinkAlt className='Link-Icon' />
                        View detailed upload instructions
                    </button>
                </div>

                <div className='Modern-Budget-Actions'>
                    <button className='Modern-Primary-Button' onClick={() => openProjectLink()}>
                        <FaExternalLinkAlt className='Button-Icon' />
                        Open Acumatica Project
                    </button>

                    <div className='Modern-Budget-Files-Grid'>
                        <button className='Modern-Secondary-Button' onClick={() => openProjectBookingTask(accessToken,budget.taskFileName)}>
                            <FaDownload className='Button-Icon' />
                            Download Tasks
                        </button>
                        <button className='Modern-Secondary-Button' onClick={() => openProjectBookingRevenue(accessToken,budget.revenueFileName)}>
                            <FaDownload className='Button-Icon' />
                            Download Revenue Budget
                        </button>
                        <button className='Modern-Secondary-Button' onClick={() => openProjectBookingCost(accessToken,budget.costFileName)}>
                            <FaDownload className='Button-Icon' />
                            Download Cost Budget
                        </button>
                    </div>

                    <button className='Modern-Success-Button' onClick={() => setBudgetCreateComplete(true)}>
                        <FaCheck className='Button-Icon' />
                        Mark Budget Upload Complete
                    </button>
                </div>
            </div>
        )
        else if(budget.type === 'ProEst') return(
            <div className='Modern-Budget-Section'>
                <div className='Modern-Budget-Header'>
                    <div className='Modern-Budget-Icon-Container'>
                        <FaCog className='Modern-Budget-Icon' />
                    </div>
                    <div className='Modern-Budget-Header-Content'>
                        <h3 className='Modern-Budget-Title'>ProEst Budget Upload</h3>
                        <p className='Modern-Budget-Subtitle'>Sync your ProEst estimate with Acumatica project</p>
                    </div>
                </div>

                <div className='Modern-Budget-Instructions'>
                    <p>Open the ProEst budget and navigate to the estimate center. Edit the estimate, then select the Acumatica project and mark status to "Awarded-Sync" and save.</p>
                    
                    <button 
                        className='Modern-Budget-Instructions-Link' 
                        onClick={() => openProEstBudgetInstructions()}
                    >
                        <FaExternalLinkAlt className='Link-Icon' />
                        View detailed workflow instructions
                    </button>
                </div>

                <div className='Modern-Budget-Actions'>
                    <div className='Modern-Budget-Links-Grid'>
                        <button className='Modern-Primary-Button' onClick={() => openProjectLink()}>
                            <FaExternalLinkAlt className='Button-Icon' />
                            Open Acumatica Project
                        </button>
                        <button className='Modern-Primary-Button' onClick={() => openProestBudgetLink(budget.estimateNumber)}>
                            <FaExternalLinkAlt className='Button-Icon' />
                            Open ProEst Estimate
                        </button>
                    </div>

                    <button className='Modern-Success-Button' onClick={() => setBudgetCreateComplete(true)}>
                        <FaCheck className='Button-Icon' />
                        Mark Budget Upload Complete
                    </button>
                </div>
            </div>
        )
        else if(budget.type === 'Sage') return(
            <div className='Modern-Budget-Section'>
                <div className='Modern-Budget-Header'>
                    <div className='Modern-Budget-Icon-Container'>
                        <FaChartBar className='Modern-Budget-Icon' />
                    </div>
                    <div className='Modern-Budget-Header-Content'>
                        <h3 className='Modern-Budget-Title'>Sage Budget Upload</h3>
                        <p className='Modern-Budget-Subtitle'>Process Sage budget export for project setup</p>
                    </div>
                </div>

                { !budget.taskFileName ? (
                    <div className='Modern-Budget-Content'>
                        <div className='Modern-Budget-Instructions'>
                            <p>Contact the submitter to ensure they push the budget to Sage and export from there, or request a budget file from them.</p>
                            <p>After receiving an Excel file of the export, upload it below.</p>
                            
                            <button 
                                className='Modern-Budget-Instructions-Link' 
                                onClick={() => openSageBudgetInstructions()}
                            >
                                <FaExternalLinkAlt className='Link-Icon' />
                                View detailed workflow instructions
                            </button>
                        </div>

                        <div className='Modern-Budget-Upload-Section'>
                            <div className='Modern-File-Upload'>
                                <input 
                                    type='file' 
                                    id='budgetExport'
                                    className='Modern-File-Input' 
                                    onChange={e => setBudgetExport(e.target.files[0])} 
                                />
                                <label htmlFor='budgetExport' className='Modern-File-Label'>
                                    <FaUpload className='Upload-Icon' />
                                    {budgetExport ? budgetExport.name : 'Choose Sage Budget Export File'}
                                </label>
                            </div>

                            {budgetExport && (
                                <button className='Modern-Primary-Button' onClick={() => formatExport(budgetExport)}>
                                    <FaCog className='Button-Icon' />
                                    Format Budget Export
                                </button>
                            )}
                        </div>

                        <div className='Modern-Budget-Actions'>
                            <button className='Modern-Primary-Button' onClick={() => openProjectLink()}>
                                <FaExternalLinkAlt className='Button-Icon' />
                                Open Acumatica Project
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className='Modern-Budget-Content'>
                        {   !updatingBudget &&
                        <>
                        <div className='Modern-Budget-Instructions'>
                            <p>Download the task, revenue, and cost files below and upload them into the project.</p>
                            
                            <button 
                                className='Modern-Budget-Instructions-Link' 
                                onClick={() => openStandardBudgetInstructions()}
                            >
                                <FaExternalLinkAlt className='Link-Icon' />
                                View detailed upload instructions
                            </button>
                        </div>

                        <div className='Modern-Budget-Actions'>
                            <button className='Modern-Primary-Button' onClick={() => openProjectLink()}>
                                <FaExternalLinkAlt className='Button-Icon' />
                                Open Acumatica Project
                            </button>

                            <div className='Modern-Budget-Files-Grid'>
                                <button className='Modern-Secondary-Button' onClick={() => openProjectBookingTask(accessToken,budget.taskFileName)}>
                                    <FaDownload className='Button-Icon' />
                                    Download Tasks
                                </button>
                                <button className='Modern-Secondary-Button' onClick={() => openProjectBookingRevenue(accessToken,budget.revenueFileName)}>
                                    <FaDownload className='Button-Icon' />
                                    Download Revenue Budget
                                </button>
                                <button className='Modern-Secondary-Button' onClick={() => openProjectBookingCost(accessToken,budget.costFileName)}>
                                    <FaDownload className='Button-Icon' />
                                    Download Cost Budget
                                </button>
                            </div>

                            <div className='Modern-Budget-Upload-Section'>
                            <div className='Modern-File-Upload'>
                                <input 
                                    type='file' 
                                    id='budgetExport'
                                    className='Modern-File-Input' 
                                    onChange={e => setBudgetExport(e.target.files[0])} 
                                />
                                <label htmlFor='budgetExport' className='Modern-File-Label'>
                                    <FaUpload className='Upload-Icon' />
                                    {budgetExport ? budgetExport.name : 'Choose Sage Budget Export File'}
                                </label>
                            </div>

                            {budgetExport && (
                                <button className='Modern-Primary-Button' onClick={() => formatBudgetExport()}>
                                    <FaCog className='Button-Icon' />
                                    Format Budget Export
                                </button>
                            )}
                            </div>

                            <button className='Modern-Success-Button' onClick={() => setBudgetCreateComplete(true)}>
                                <FaCheck className='Button-Icon' />
                                Mark Budget Upload Complete
                            </button>
                        </div>
                        </>
                        }
                        { updatingBudget && 
                            <div className='Modern-Budget-Status-Card'>
                                <div className='Modern-Status-Loading'>
                                    <Loader />
                                </div>
                                <div className='Modern-Status-Content'>
                                    <h3 className='Modern-Status-Title'>Updating Budget</h3>
                                    <p className='Modern-Status-Description'>Please wait while we process your budget upload...</p>
                                </div>
                            </div>
                        }   
                    </div>
                )}
            </div>
        )
        else return(
            <div className='Modern-Budget-Section'>
                <div className='Modern-Budget-Header'>
                    <div className='Modern-Budget-Icon-Container Modern-Budget-Icon-Warning'>
                        <FaExclamationTriangle className='Modern-Budget-Icon' />
                    </div>
                    <div className='Modern-Budget-Header-Content'>
                        <h3 className='Modern-Budget-Title'>No Budget Provided</h3>
                        <p className='Modern-Budget-Subtitle'>Budget upload required to complete project booking</p>
                    </div>
                </div>

                <div className='Modern-Budget-Instructions'>
                    <p>No budget has been uploaded. Please send an email to the submitter and ensure they are aware this will be required to finish project booking.</p>
                </div>

                <div className='Modern-Budget-Actions'>
                    <button className='Modern-Primary-Button' onClick={() => openProjectLink()}>
                        <FaExternalLinkAlt className='Button-Icon' />
                        Open Acumatica Project
                    </button>
                </div>
            </div>
        );
    };

    return(
        <div className='Modern-Approval-Container'>
            {!projectCreateComplete && (
                <div className='Modern-Approval-Status-Card'>
                    <div className='Modern-Status-Loading'>
                        <Loader />
                    </div>
                    <div className='Modern-Status-Content'>
                        <h3 className='Modern-Status-Title'>Booking Project</h3>
                        <p className='Modern-Status-Description'>Please wait while we create your project in Acumatica...</p>
                    </div>
                </div>
            )}

            {projectCreateComplete && !closingProjectCreate && (
                <div className='Modern-Approval-Status-Card Modern-Status-Success'>
                    <div className='Modern-Status-Icon-Container'>
                        <FaCheck className='Modern-Status-Icon' />
                    </div>
                    <div className='Modern-Status-Content'>
                        <h3 className='Modern-Status-Title'>Project Successfully Booked</h3>
                        <p className='Modern-Status-Description'>Moving to budget setup phase...</p>
                    </div>
                </div>
            )}

            {projectCreateComplete && closingProjectCreate && !budgetCreateComplete && (
                <div className='Modern-Budget-Container'>
                    <div className='Modern-Budget-Navigation'>
                        <button className='Modern-Back-Button' onClick={() => goBackToReview()}>
                            <FaBackward className='Button-Icon' />
                            Back to Review
                        </button>
                    </div>
                    <BudgetInputWindow />
                </div>
            )}

            {projectCreateComplete && closingProjectCreate && budgetCreateComplete && !closingBudgetSubmit && !approvalFinished && (
                <div className='Modern-Approval-Status-Card'>
                    <div className='Modern-Status-Loading'>
                        <Loader />
                    </div>
                    <div className='Modern-Status-Content'>
                        <h3 className='Modern-Status-Title'>Finalizing Project Budget</h3>
                        <p className='Modern-Status-Description'>Please wait while we process your budget setup...</p>
                    </div>
                </div>
            )}

            {approvalFinished && (
                <div className='Modern-Approval-Status-Card Modern-Status-Complete'>
                    <div className='Modern-Status-Icon-Container'>
                        <FaCheck className='Modern-Status-Icon' />
                    </div> 
                    <div className='Modern-Status-Content'>
                        <h3 className='Modern-Status-Title'>Project Booking Complete</h3>
                        <p className='Modern-Status-Description'>Request has been marked as inactive and project is ready for use.</p>
                    </div>
                </div>
            )}
        </div>
    );
};

const ProjectBookingReview = () => {
    const contextObject = useContext(Context);

    const [recordId, setRecordId] = useState();

    const [orderBy, setOrderBy ] = useState('date');

    const [sortDirection, setSortDirection ] = useState('ASC');
    const [activeSort, setActiveSort ] = useState(true);

    const [updatingBudget, setUpdatingBudget] = useState(false);

    const [rejectedRecord, setRejectedRecord] = useState();
    const [requestList, setRequestList ] = useState();
    const [requestRecord, setRequestRecord] = useState();
    const [searchInput, setSearchInput ] = useState('');
    const [searchList, setSearchList] = useState([]);

    const [serviceContracts, setServiceContracts] = useState([]);
    const [serviceContractsError, setServiceContractsError] = useState('');

    const [approving, setApproving ] = useState(false);
    const [projectCreateComplete, setProjectCreateComplete] = useState(false);
    const [budgetCreateComplete, setBudgetCreateComplete] = useState(false);
    const [approvalFinished, setApprovalFinished ] = useState(false);
    const [serviceContractsRequired, setServiceContractsRequired] = useState(false);

    const [boxLink, setBoxLink] = useState('');
    const [acumaticaLink, setAcumaticaLink] = useState('');
    const [bookedServiceContracts, setBookedServiceContracts] = useState();

    const updateServiceContract = (contract, id, operation) => {
        let tempList = serviceContracts;
        if(operation === 'Edit'){
            tempList[id] = contract;
        }
        if(operation === 'Delete'){
            tempList = tempList.slice(id,1)
        }
        
        setServiceContracts(tempList);
    };

    const goBackToReview = () => {
        setApproving(false);
    };

    const continueApproving = () => {
        setApproving(true);
    };

    const finalizeProjectBooking  = () => {
        newProjectBookingDataService.markRequestComplete(contextObject.apiToken, requestRecord.id);
        setApprovalFinished(true);
        markInactive();
    };

    useEffect(() => {
        if(requestRecord && budgetCreateComplete){
            newProjectBookingDataService.markRequestComplete(contextObject.apiToken, requestRecord.id);
            setTimeout(() => {
                setApprovalFinished(true);
            },1000);
        };
    },[budgetCreateComplete]);

    useEffect(() => {
        if(requestRecord){
            if(requestRecord.projectType) {
                if(requestRecord.projectType === 'Service'){
                    setServiceContractsRequired(true);
                    getServiceContracts(contextObject.apiToken, requestRecord.id,setServiceContracts,setServiceContractsError);
                }
                else setServiceContractsRequired(false);
            };

            if(requestRecord.acumaticaProjectId) {
                setApprovalFinished(false);
                setProjectCreateComplete(true);
                setAcumaticaLink(`https://cornerstoneinc.acumatica.com/(W(7))/Main?CompanyID=Pilot&ScreenId=PM301000&BaseType=P&ContractCD=${requestRecord.acumaticaProjectId}`);
            };

            if(requestRecord.boxFolderId){
                setBoxLink(`https://cornerstonedetentionproducts.app.box.com/folder/${requestRecord.boxFolderId}`);
            };

            if(requestRecord.completeDate){
                setApprovalFinished(true);
            };

            if(requestRecord.serviceContracts){
                setBudgetCreateComplete(true);
                setBookedServiceContracts(requestRecord.serviceContracts);
            }

            newProjectBookingDataService.getRejectedRecord(contextObject.apiToken, requestRecord.id).then(res => setRejectedRecord(res.data.rejection));
        }
    },[requestRecord]);

    const approveRecord = async (currency) => {
        setApprovalFinished(false);
        setApproving(true);
        
        const approvalObject = {
            id: recordId,
            currency: currency,
        };
        try{
            const approval = await newProjectBookingDataService.approveRecord(contextObject.apiToken, approvalObject);

            const boxFolderId = approval.data.box;
            const acumaticaId = approval.data.acumatica;
            if(approval.status > 199 && approval.status < 300){
                selectRecord(recordId);
                setProjectCreateComplete(true);
                setBoxLink(`https://cornerstonedetentionproducts.app.box.com/folder/${boxFolderId}`);
                setAcumaticaLink(`https://cornerstoneinc.acumatica.com/(W(7))/Main?CompanyID=Pilot&ScreenId=PM301000&BaseType=P&ContractCD=${acumaticaId}`);
            }
            else{
                alert('SERVER FAILURE - Please Contact IT for assistance');
            };
        }
        catch(error){
            alert('SERVER FAILURE - Please Contact IT for assistance');
            closeRecord();
        }
    };

    const closeWindow = () => {
        setRecordId(null);
        setApproving(false);
        setApprovalFinished(false);
        setProjectCreateComplete(false);
        setBudgetCreateComplete(false);
        setApprovalFinished(false);
        setServiceContractsRequired(false);

        refreshList();
        setSearchInput('');
    };

    const rejectRecord = ( rejectionText, closeRejection) => {
        const rejection = {
            requestId: requestRecord.id,
            text: rejectionText,
        };

        newProjectBookingDataService.rejectRecord(contextObject.apiToken, rejection).then(res => {closeRejection(); selectRecord(recordId);});
    };

    const markInactive = () => {
        newProjectBookingDataService.inactivateRecord(contextObject.apiToken, recordId).then(res => {closeRecord(); refreshList()});
    };

    const markActive = () => {
        newProjectBookingDataService.activateRecord(contextObject.apiToken, recordId).then(res => {closeRecord(); refreshList()});
    };

    const closeRecord = () => {
        setRecordId(null);
        setApproving(false);
        setApprovalFinished(false);
        setProjectCreateComplete(false);
        setBudgetCreateComplete(false);
        setApprovalFinished(false);
        setServiceContractsRequired(false);
    };

    const resetList = () => {
        setSearchInput('');
        setOrderBy('date');
        setActiveSort(true);
        refreshList();
        setSortDirection('ASC');
    };

    const selectSearchItem = (projectName) => {
        const filterObject = {
            searchInput:projectName,
        };
        newProjectBookingDataService.getList(contextObject.apiToken, filterObject).then(res => setRequestList(res.data.projectBookingList));
    };

    const refreshSearchList = async () => {
        if(searchInput){
            const searchObject = {
                searchInput: searchInput,
            };
            newProjectBookingDataService.getSearchList(contextObject.apiToken, searchObject).then(res => setSearchList(res.data.searchList));
        }
    };

    useEffect(() => {
        refreshSearchList();
    },[searchInput]);

    const selectRecord = (id) => {
        setRecordId(id);
        newProjectBookingDataService.getRecord(contextObject.apiToken, id).then(res => setRequestRecord(res.data.record));
    };

    const flipSortOrder = () => {
        if(sortDirection === 'ASC') setSortDirection('DESC');
        else setSortDirection('ASC');
    };

    const handleOrderClick = (newOrderBy) => {
        if(newOrderBy === orderBy) flipSortOrder();
        else setOrderBy(newOrderBy)
    };

    const toggleFlag = (id) => {
        newProjectBookingDataService.toggleFlag(contextObject.apiToken, id).then(res => refreshList());
    };

    const refreshList = () => {
        const filterObject = {
            active: activeSort,
            sortDirection: sortDirection,
            orderBy:orderBy,
            searchInput:searchInput,
        };
        newProjectBookingDataService.getList(contextObject.apiToken, filterObject).then(res => setRequestList(res.data.list));
    };

    const formatExport = (file) => {
        setUpdatingBudget(true);
        const filename = `${requestRecord.projectName}-Original Budget-${getDate()}.xlsx`;
        newProjectBookingDataService.uploadBudget(contextObject.apiToken, file, filename).then(res => {
            if(res.status > 199 && res.status < 300){
                const updatedRecord = requestRecord;

                updatedRecord.projectName = requestRecord.name;

                updatedRecord.budgetResponse = res.data
                newProjectBookingDataService.updateRecord(contextObject.apiToken,updatedRecord).then(res => {
                    if(res.data.id){
                        selectRecord(res.data.id);
                        setUpdatingBudget(false);
                    };  
                });
            }
            else{
                alert('SERVER FAILURE - Please Contact IT for assistance'); 
            };
        });
    };

    useEffect(() => {
        refreshList();
    },[sortDirection, orderBy, activeSort]);

    const headerObject = {
        setSearchInput:setSearchInput,
        sortDirection:sortDirection,
        flipSortOrder:flipSortOrder,
        screenWidth:contextObject.screenWidth,
        handleOrderClick:handleOrderClick,
        orderBy: orderBy,
        searchList:searchList,
        selectSearchItem:selectSearchItem,
        resetList:resetList,
        activeSort:activeSort,
        setActiveSort:setActiveSort,
        screenWidth: contextObject.screenWidth,
    };

    const listObject = {
        requestList:requestList,
        selectRecord:selectRecord,
        toggleFlag:toggleFlag,
        screenWidth: contextObject.screenWidth,
    };

    const recordObject = {
        requestRecord:requestRecord,
        setRequestRecord:setRequestRecord,
        closeRecord:closeRecord,
        markInactive:markInactive,
        markActive:markActive,
        approveRecord:approveRecord,
        contextObject: contextObject,
        rejectRecord:rejectRecord,
        selectRecord:selectRecord,
        rejectedRecord:rejectedRecord,
        serviceContracts:serviceContracts,
        updateServiceContract:updateServiceContract,
        projectCreateComplete:projectCreateComplete,
        continueApproving:continueApproving,
        approvalFinished:approvalFinished,
    };

    return(
        <div className='Project-Booking-Review'>
            {   !recordId && !approving &&
            <>
                <RequestHeader headerObject={headerObject}/>
                <RequestDisplay listObject={listObject}/>      
            </>
            }
            {   recordId && !approving &&
                <RecordWindow accessToken={contextObject.apiToken} recordObject={recordObject}/>
            }
            {   approving &&
                <ApprovalWindow accessToken={contextObject.apiToken} approvalFinished={approvalFinished} projectCreateComplete={projectCreateComplete} projectAlreadyCreated={`${requestRecord.acumaticaProjectId ? true : false}`} closeWindow={closeWindow} 
                boxLink={boxLink} acumaticaLink={acumaticaLink} budgetCreateComplete={budgetCreateComplete} setBudgetCreateComplete={setBudgetCreateComplete} budgetAlreadyCreated={false} budget={requestRecord.budget} 
                serviceContractsRequired={serviceContractsRequired} setApprovalFinished={setApprovalFinished} goBackToReview={goBackToReview} bookedServiceContracts={bookedServiceContracts} finalizeProjectBooking={finalizeProjectBooking} markInactive={markInactive}
                formatExport={formatExport} updatingBudget={updatingBudget}/>
            }
        </div>
    )
};

export default ProjectBookingReview;